export default "__VITE_ASSET__B$ivhAYS__"